import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Label,Input,Modal,ModalHeader,Button } from "reactstrap";
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Users() {
    const[email,setEmail] = useState('');
    const[company,setCompany]=useState('');
    const [users, setUsers] = useState([]);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [username, setUsername] = useState("");
    const [firstname, setFirstname] = useState('');
    const [middlename, setMiddlename] = useState('');
    const [lastname, setLastname] = useState("");
    const [useremail, setUseremail] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const [submitText, setSubmittext] = useState('Submit');
    const [selectedUser, setSelecteduser] = useState('');
    const [updateText, setUpdatetxt] = useState('Update user')
    const [suspendText, setSuspendtext] = useState("Confirm")


    const toggle =()=>{
        setModal(!modal)
    }

    

    useEffect(() => {
                const fetchProfile = async () => {
                  try {
                    const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
                      credentials: 'include', // to send cookies
                    });
                    const data = await res.json();
            
                    if (data.valid) {
                      setEmail(data.email)
                    } else {}
                  } catch (error) {} 
                };
            
                fetchProfile();
              }, []);
            
              //get store id
              useEffect(()=>{
               const fetchData = async()=>{
                  try{
                    const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
                    const data = await res.json();
                    setCompany(data.company)
                  }
                  catch(err){}
               }
            
               if(email){
                fetchData();
               }
               
              },[email]);
    

    useEffect(()=>{
        const fetchUsers =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCompanyusers?company=${company}`);
            const data = await res.json();
            setUsers(data);
        }

        if(company){
            fetchUsers();
        }
    },[company])

    const fetchUsers =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCompanyusers?company=${company}`);
            const data = await res.json();
            setUsers(data);
        }

    const submitUser =async()=>{
        if(username && firstname && middlename && lastname && useremail && phone && role){
            setSubmittext('Please wait...');
            const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/submitUser',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({username,firstname,middlename,lastname,useremail,phone,company,role}),
                credentials:"include"
            })

            const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Data saved successfully');
                setSubmittext('Submit')
                fetchUsers();
                setUseremail('')
                setUsername('')
                setFirstname('')
                setMiddlename('')
                setLastname('')
                setPhone('')
                setRole('')
                setModal(false)
            }
            else{
                toast.error('Something went wrong!')
                setSubmittext('Submit')
            }
        }
        else{
            toast.error('All fields are required')
        }
    }

    const toggle2 =async(e)=>{
        const id = e.target.value;
        setSelecteduser(id);
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getThisuser?id=${id}`);
        const data = await res.json();
        setUsername(data.username);
        setFirstname(data.firstname);
        setMiddlename(data.middlename);
        setLastname(data.lastname);
        setUseremail(data.email);
        setPhone(data.phone);
        setRole(data.role);
        setModal2(!modal2);
        
    }


    const updateUser =async()=>{
        setUpdatetxt('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/updateUser',{
            method:'POST',
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({username,firstname,middlename,lastname,useremail,phone,company,role,selectedUser}),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('Data saved successfully');
                setUpdatetxt('Update user')
                fetchUsers();
                setUseremail('')
                setUsername('')
                setFirstname('')
                setMiddlename('')
                setLastname('')
                setPhone('')
                setRole('')
                setModal2(false)
            }
            else{
                toast.error('Something went wrong!')
                setUpdatetxt('Update user')
            }
    }


    const toggle3 =async()=>{
        setModal3(!modal3)
    }

    const suspendUser =async()=>{
        setSubmittext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/suspendUser',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({selectedUser}),
            credentials:"include"
        })

        const data = await res.json();
            const {success} = data;
            if(success == true){
                toast.success('User has been suspended');
                setSuspendtext('Confirm')
                fetchUsers();
                setUseremail('')
                setUsername('')
                setFirstname('')
                setMiddlename('')
                setLastname('')
                setPhone('')
                setRole('')
                setModal2(false)
                setModal3(false)
            }
            else{
                toast.error('Something went wrong!')
                setSuspendtext('Confirm')
            }
    }

            
  return (
    <div className="pagesContainer">
    <ToastContainer />
        <Breadcrumbs title="Easybox" breadcrumbItem="Users" />
        <div className="card" style={{padding:'10px'}}>
        <div className="">
                <Button color='info' onClick={toggle} >+ Add User</Button>
        </div> 
        <hr />
        <div className="table-responsive">
        <Table striped bordered hover id="dataTable">

            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Username</th>
                    <th scope="col">First name</th>
                    <th scope="col">Middle name</th>
                    <th scope="col">Last name</th> 
                    <th scope="col">Email</th>  
                    <th scope="col">Phone</th> 
                    <th scope="col">Role</th>   
                    <th scope="col">Status</th> 

                </tr>
            </thead>
            <tbody>
            {users.map((val,index)=>{
                
                return(
                    <tr>
                        <td>{index+1}</td>
                        <td><button className="tableButton" value={val.id} onClick={toggle2}>{val.username}</button></td>
                        <td>{val.firstname}</td>
                        <td>{val.middlename}</td>
                        <td>{val.lastname}</td>
                        <td>{val.email}</td>
                        <td>{val.phone}</td>
                        <td>{val.role}</td>
                        <td>{val.status}</td>
                    </tr>
                )
            })}
            </tbody>
            </Table>
        </div>
        </div>


    <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Add new user</ModalHeader>
        <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter username" onChange={(e)=>{setUsername(e.target.value)}}>
                <Form.Control  className='inputSearch' value={username}  type="text" placeholder="Enter username" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter first name" onChange={(e)=>{setFirstname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={firstname}  type="text" placeholder="Enter first name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter middle name" onChange={(e)=>{setMiddlename(e.target.value)}}>
                <Form.Control  className='inputSearch' value={middlename}  type="text" placeholder="Enter middle name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter Last name" onChange={(e)=>{setLastname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={lastname}  type="text" placeholder="Enter Last name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter Email" onChange={(e)=>{setUseremail(e.target.value)}}>
                <Form.Control  className='inputSearch' value={useremail}  type="text" placeholder="Enter email" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter phone" onChange={(e)=>{setPhone(e.target.value)}}>
                <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="Enter phone" />
        </FloatingLabel>
        <div className="mb-4" id='mb'>
                       
        <Label className="form-label">Role</Label>
        <select name="" id="" className="form-control" onChange={(e)=>{setRole(e.target.value)}}>
            <option selected disabled>- ROLE - </option>
            <option value='Admin'>Admin</option>
            <option value='Dispatch'>Dispatch</option>
            <option value='Operations'>Operations</option>
        
        </select>
        </div>

        <Button color='success' onClick={submitUser}>{submitText}</Button>
        
        </div>
    </Modal>

    <Modal isOpen={modal2} toggle={toggle2}>
        <ModalHeader>Edit {username}</ModalHeader>
        <div className="modalContainer">
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter username" onChange={(e)=>{setUsername(e.target.value)}}>
                <Form.Control  className='inputSearch' value={username}  type="text" placeholder="Enter username" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter first name" onChange={(e)=>{setFirstname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={firstname}  type="text" placeholder="Enter first name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter middle name" onChange={(e)=>{setMiddlename(e.target.value)}}>
                <Form.Control  className='inputSearch' value={middlename}  type="text" placeholder="Enter middle name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter Last name" onChange={(e)=>{setLastname(e.target.value)}}>
                <Form.Control  className='inputSearch' value={lastname}  type="text" placeholder="Enter Last name" />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter Email" >
                <Form.Control  className='inputSearch' value={useremail}  type="text" placeholder="Enter email" disabled />
        </FloatingLabel>
        <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Enter phone" onChange={(e)=>{setPhone(e.target.value)}}>
                <Form.Control  className='inputSearch' value={phone}  type="text" placeholder="Enter phone" />
        </FloatingLabel>
        <div className="mb-4" id='mb'>
                       
        <Label className="form-label">Role</Label>
        <select name="" id="" className="form-control" onChange={(e)=>{setRole(e.target.value)}}>
            <option selected disabled>{role} </option>
            <option value='Admin'>Admin</option>
            <option value='Dispatch'>Dispatch</option>
            <option value='Operations'>Operations</option>
        
        </select>
        </div>
        <div className="modalButtons">
            <Button color='success' onClick={updateUser}>{updateText}</Button>
            <Button color='danger' onClick={toggle3} style={{marginLeft:'2%'}}>Suspend user</Button>
        </div>
       
        <p style={{color:'red',textAlign:'right',cursor:'pointer'}} onClick={()=>{setModal2(false)}}>Close</p>
        </div>
    </Modal>

    <Modal isOpen={modal3} toggle={toggle3}>
        <ModalHeader>Confirm user suspension</ModalHeader>
        <div className="modalContainer">
            <p>Confirm you want to suspend {username}</p>
            <div className="modalButtons">
                <Button color='success' onClick={suspendUser}>{suspendText}</Button>
                <Button color='danger' style={{marginLeft:'2%'}} onClick={()=>{setModal3(false)}}>Cancel</Button>
            </div>
        </div>
    </Modal>
    </div>
  )
}
